import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { SOPQModal } from './promos/hotels-promo-collection/sopq-promo'
import HotelFormState from '../stores/HotelFormsState'
import HotelSearchActions from '../actions/HotelSearchActions'
import ExpressDealsBanner from './Express-Deals-Banner'
const __changeListener = Symbol('changeListener')

class HotelSOPQFeature extends Component {
  static propTypes = {
    entryContent: PropTypes.object,
    defaultFormData: PropTypes.object,
    showMobileClass: PropTypes.string,
    formContent: PropTypes.object
  }

  constructor () {
    super()

    this[__changeListener] = null
    this.state = {
      showModal: false
    }
  }

  componentDidMount () {
    if (this[__changeListener]) return

    this[__changeListener] = this.__onChange.bind(this)

    HotelFormState.addChangeListener(this[__changeListener])
  }

  componentWillUnmount () {
    if (!this[__changeListener]) return

    HotelFormState.removeChangeListener(this[__changeListener])

    this[__changeListener] = null
  }

  __onChange () {
    const isFormVisible = HotelFormState.isVisible('sopq-hotels')

    if (isFormVisible !== this.state.showModal) {
      this.toggleModal()
    }
  }

  handleModalOpen (event) {
    HotelSearchActions.toggleSOPQForm(true)

    if (event && event.preventDefault) event.preventDefault()
  }

  handleModalClose (event) {
    HotelSearchActions.toggleSOPQForm(false)

    if (event && event.preventDefault) event.preventDefault()
  }

  toggleModal () {
    this.setState({ showModal: !this.state.showModal })
  }

  render () {
    const defaultFormData = this.props.defaultFormData || {}
    const mobileClass = this.props.showMobileClass || ''

    return (
      <div className='HotelSOPQFeature'>
        <ExpressDealsBanner
          content={this.props.entryContent}
          onCTAClick={this.handleModalOpen}
          showMobileClass={mobileClass}
        />
        {this.state.showModal &&
          <SOPQModal
            show={this.state.showModal}
            onClose={this.handleModalClose}
            content={this.props.formContent}
            initialValues={defaultFormData.hotels}
          />
        }
      </div>
    )
  }
}

export default HotelSOPQFeature
